import { ReactNode, MouseEvent } from 'react';
import type { CommonHTMLButtonAttributes } from '@frontend/types';
import { NakedButton } from '../../../naked';
import { TabFilterStyles } from './styles';

type Props = CommonHTMLButtonAttributes & {
  children: ReactNode;
  id: string;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
  trackingId?: string;
};

export const Tab = ({ children, ...rest }: Props) => {
  const styles = TabFilterStyles.tabItem;
  return (
    <NakedButton css={styles} {...rest}>
      {children}
    </NakedButton>
  );
};
